"use strict";

export var MainConstants = {
  NAVIGATE_TO_MAIN: 'NAVIGATE_TO_MAIN',
  NAVIGATE_TO_LOGIN: 'NAVIGATE_TO_LOGIN'
};